import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Layout } from '@/routes/_layout';
import { HomeRoute } from '@/routes/home';
import { StallRoute } from '@/routes/stall';
import { SearchRoute } from '@/routes/search';
import { SignInRoute } from '@/routes/signin';
import { AddRoute } from '@/routes/add';
import { ProfileRoute } from '@/routes/profile';
import { ReviewsRoute } from '@/routes/reviews';
import { NotificationsRoute } from '@/routes/notifications';
import { OnboardingRoute } from '@/routes/onboarding';
import { StatesRoute, NotFoundRoute } from '@/routes/placeholders';
import { AuthProvider } from '@/auth/AuthContext';
import { ToastProvider } from '@/hooks/useToast';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<HomeRoute />} />
                <Route path="/home" element={<HomeRoute />} />
                <Route path="/stall/:id" element={<StallRoute />} />
                <Route path="/search" element={<SearchRoute />} />
                <Route path="/add" element={<AddRoute />} />
                <Route path="/profile" element={<ProfileRoute />} />
                <Route path="/reviews/:id?" element={<ReviewsRoute />} />
                <Route path="/notifications" element={<NotificationsRoute />} />
                <Route path="/onboarding" element={<OnboardingRoute />} />
                <Route path="/states" element={<StatesRoute />} />
                <Route path="/signin" element={<SignInRoute />} />
                <Route path="*" element={<NotFoundRoute />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
